"use client";
import { ConfirmDialog } from "@ea/ui/components/Dialog/ConfirmDialog";
import { OverlayProps, useOverlayStore } from "@ea/ui/components/OverlayManager/useOverlayStore";
import { Typography } from "@ea/ui/components/Typography";
import { useTranslations } from "@ea/ui/translations/useTranslations";
type PropTypes = {
  onConfirm: () => void;
};

export function ConfirmLoginDialog({ isOpen, onConfirm }: OverlayProps<PropTypes>) {
  const { t } = useTranslations("Login");
  const { close } = useOverlayStore();

  const closeDialog = () => close(ConfirmLoginDialog);

  return (
    <ConfirmDialog
      type="warning"
      onClose={closeDialog}
      onConfirm={() => {
        closeDialog();
        onConfirm();
      }}
      open={isOpen || false}
      title={t("alert.title")}
      controls={{
        confirm: t("alert.confirm"),
        cancel: t("alert.cancel"),
      }}
    >
      <Typography>{t("alert.info")}</Typography>
    </ConfirmDialog>
  );
}
